<mat-form-field>
  @if (labelTranslateKey) {
    <mat-label [translate]="labelTranslateKey"> </mat-label>
  }
  @switch (type) {
    @case ('textarea') {
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        [formControl]="control"
        [placeholder]="placeholderTranslateKey ? (placeholderTranslateKey | translate) : ''"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="valueChange.emit(control.value)"
        [attr.maxlength]="getMaxLengthFromValidator()"
        #input
      ></textarea>
    }
    @case ('number') {
      <input
        matInput
        [formControl]="control"
        type="number"
        [placeholder]="placeholderTranslateKey ? (placeholderTranslateKey | translate) : ''"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="valueChange.emit(control.value)"
        [attr.maxlength]="getMaxLengthFromValidator()"
        #input
      />
    }
    @default {
      <input
        matInput
        [formControl]="control"
        [type]="type"
        [placeholder]="placeholderTranslateKey ? (placeholderTranslateKey | translate) : ''"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="valueChange.emit(control.value)"
        [attr.maxlength]="getMaxLengthFromValidator()"
        #input
      />
    }
  }

  @if (prefix) {
    <span matPrefix class="field-prefix">{{ prefix }}</span>
  }
  @if (suffix) {
    <span matSuffix class="field-suffix">{{ suffix }}</span>
  }

  @if (hintTranslateKey && hintTranslateKey.length) {
    <mat-hint [translate]="hintTranslateKey"></mat-hint>
  }
  @if (hintTemplate) {
    <mat-hint><ng-content select="[hint]"> </ng-content></mat-hint>
  }
  @if (showCounter && maxLength) {
    <mat-hint align="end"> {{ currentLength }} / {{ maxLength }} </mat-hint>
  }
  @if (!!control?.hasError('required') && showRequiredError) {
    <mat-error translate="FORMS.ERROR.FIELD_REQUIRED"></mat-error>
  }
  @if (!!control?.hasError('min')) {
    <mat-error>
      {{ 'FORMS.ERROR.MIN' | translate: { min: control?.getError('min').min.toFixed(2) } }}
    </mat-error>
  }
  @if (!!control?.hasError('max')) {
    <mat-error>
      {{ 'FORMS.ERROR.MAX' | translate: { max: control?.getError('max').max.toFixed(2) } }}
    </mat-error>
  }
  @if (!!control?.hasError('minlength')) {
    <mat-error>
      {{ 'FORMS.ERROR.MIN_LENGTH' | translate: { requiredLength: control?.getError('minlength').requiredLength } }}
    </mat-error>
  }
  @if (!!control?.hasError('wholeNumber')) {
    <mat-error>
      {{ 'FORMS.ERROR.WHOLE_NUMBER' | translate }}
    </mat-error>
  }
  @if (!!control?.hasError('email')) {
    <mat-error translate="FORMS.ERROR.EMAIL"></mat-error>
  }
  @if (!!control?.hasError('noMatch')) {
    <mat-error>
      {{ noMatchErrorTranslateKey || 'FORMS.ERROR.INCORRECT' | translate }}
    </mat-error>
  }
  @if (!!control?.hasError('upperLowerCase')) {
    <mat-error>
      {{ 'FORMS.ERROR.UPPER_LOWER_CASE' | translate }}
    </mat-error>
  }
  @if (!!control?.hasError('validPhoneNumber')) {
    <mat-error>
      {{ 'FORMS.ERROR.INVALID_PHONE_NUMBER' | translate }}
    </mat-error>
  }
  @if (!!control?.hasError('lessThanOrEqualTo')) {
    <mat-error>
      {{ 'FORMS.ERROR.LESS_THAN_OR_EQUAL_TO' | translate: { max: control?.getError('lessThanOrEqualTo') } }}
    </mat-error>
  }
  @if (!!control?.hasError('greaterThanOrEqualTo')) {
    <mat-error>
      {{ 'FORMS.ERROR.GREATER_THAN_OR_EQUAL_TO' | translate: { min: control?.getError('greaterThanOrEqualTo') } }}
    </mat-error>
  }
  @if (!!control?.hasError('totalUnitsExceeded')) {
    <mat-error>
      {{
        'FORMS.ERROR.TOTAL_UNITS_EXCEEDED'
          | translate
            : {
                max: control?.getError('totalUnitsExceeded'),
                unitName: control?.getError('unitName'),
              }
      }}
    </mat-error>
  }
  @if (!!control?.hasError('codeAlreadyExists')) {
    <mat-error translate="FORMS.ERROR.CODE_ALREADY_EXISTS"></mat-error>
  }
  @if (!!control?.hasError('alphanumericOnly')) {
    <mat-error translate="FORMS.ERROR.ALPHANUMERIC_ONLY"></mat-error>
  }
</mat-form-field>
